import { Reveal } from "./Reveal";
import { STORE } from "../lib/store";

export default function Footer() {
    return (
        <footer className="relative overflow-hidden border-t border-white/10">
            <div className="mx-auto max-w-[1440px] px-5 md:px-10 pt-20 pb-10">
                <Reveal>
                    <h2 className="font-display font-extrabold tracking-tight leading-[0.9] text-[11.5vw] text-white/10 select-none">
                        KARAGNA
                        <br />
                        .COM
                    </h2>
                </Reveal>
                <div className="mt-12 flex flex-col md:flex-row md:items-end justify-between gap-8">
                    <div className="font-mono text-xs leading-loose tracking-wider text-slate-400">
                        <p className="text-gold uppercase">{STORE.city}</p>
                        <p>{STORE.addressLine1}, {STORE.addressLine2}</p>
                        <p><a href={STORE.phoneHref} className="hover:text-gold transition-colors">{STORE.phoneDisplay}</a></p>
                    </div>
                    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">
                        Prices about 40%+ under retail · Delivery available · Inventory changes — call ahead
                        <br />© {new Date().getFullYear()} Karagna.com, Clifton NJ
                    </p>
                </div>
            </div>
        </footer>
    );
}
